import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Calculator from '../components/Calculator';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    // https://qvgroup.qv.co.nz/rating-values
    return (
      <Fragment>
        <title>PropertyHints: How to value property?</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    {
                      url: '/how-much-can-you-get',
                      name: 'How much can you get',
                    },
                  ]}
                />
                <h2 className="lead text-center">How to value property</h2>
                <hr />
                <p>
                  <strong>So how much should you offer?</strong>
                </p>
                <p>
                  This is an extremely tricky question, especially in the current market where there are more buyers
                  than properties on the market
                </p>
                <p>So what can you use to value a property?</p>
                <p>
                  <strong>GV (Government Valuation)</strong>, <strong>RV (Rating Value)</strong>, and{' '}
                  <strong>CV (Capital Value)</strong> are all terms for essentially the same thing. They are a great way
                  of getting a rough idea of how the property compares to those around it.
                </p>
                <p>
                  {' '}
                  A RV/GV/CV is an indicative market value at the date of valuation. It is undertaken on behalf of your
                  council around every three years and is established using a mass appraisal process. It is mainly used
                  to apportion rates within your area. Every property in New Zealand has an RV. This can be useful to
                  know as it gives a guide to the price when buying and selling, but because it is only updated around
                  every three years and the market may have moved, it might not give a true indication of the current
                  market value of a property.
                </p>

                <div className="paper paper-black">
                  <p>
                    This value is made up of three components
                    <ul>
                      <li>
                        Capital Value (CV) - this is what your property is likely to have sold for at the date of your
                        local council's last general revaluation, excluding chattels.
                      </li>
                      <li>
                        Land Value (LV) - the most likely selling price of the bare land at the date of your local
                        council's last general revaluation.
                      </li>
                      <li>
                        Improvement Value (IV) - this is just the difference between the land value and capital value.
                        It is important to note here it does not mean the replacement cost of buildings and services on
                        a property.
                      </li>
                    </ul>
                  </p>
                </div>
                <br />
                <p>
                  So now that you have this, you can start to make a bit of an educated guess, but if the property
                  hasn't been revalued recently then the RV could be a long way out. This is where sites like{' '}
                  <a href="https://www.trademe.co.nz/property/insights/">Trademe Property Insights</a>, or{' '}
                  <a href="https://homes.co.nz/">homes.co.nz</a> can come in very handy, they show an estimate of what
                  the property is likely to sell for in the current market. Unlike the council valuations, these
                  services future rely on getting it pretty close, so they can be a great source of info
                </p>

                <p>
                  For many areas in NZ there will be a rough value over the RV that properties will be selling at, when
                  we started looking it was around 20% of the RV, so a house with a 300k RV would be selling for around
                  360k. By the time we managed to purchase our house it was closer to 60% over RV. This sort of thing
                  can be a bit of a mind game when putting an offer in, as you can bet that everyone else is doing the
                  same sort of maths to end up at roughly the same values.
                </p>
                <p>
                  At the end of the day, you will probably have to go with your gut and find a value that fits into your
                  budget, that should be higher than the competition, ,and that you don’t think you will regret paying
                  once you have purchased it. Sadly there’s no magic formula
                </p>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Valuation.jsx